import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/close.svg'


const _hoisted_1 = { class: "dialog" }
const _hoisted_2 = { class: "pane" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "content" }

import {  onMounted, reactive } from "vue";
interface SuccessState {
    text: string;
    title: string;
    isShow: boolean;
    name: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'textdialog',
  props: {
    text: {
        type: String,
        default: "",
    },
    title: {
        type: String,
        default: "",
    },
},
  emits: ["result"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;
const state = reactive<SuccessState>({
    text: props.text,
    title: props.title,
    isShow: true,
    name: "",
});

const onCancel = () => {
    state.isShow = false;
    emit("result", {});
};

onMounted(() => { });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (state.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(state.title), 1),
            _createElementVNode("img", {
              src: _imports_0,
              alt: "X",
              class: "close",
              onClick: onCancel
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString(state.text), 1)
      ]),
      _createElementVNode("div", {
        class: "change",
        onClick: onCancel
      }, "关闭")
    ]),
    _createElementVNode("div", {
      class: "overlay",
      onClick: onCancel
    })
  ]))
}
}

})